module.exports = __webpack_public_path__ + "images/icon-service91edb79dd8cfb490b2e6eef09cea1ca1.png";